import { gql } from "@grandvisionhq/graphql";
import { productFragment } from "../../fragments/operations/queries/fragments/product.js";
import { variantFragment } from "../../fragments/operations/queries/fragments/variant.js";
import { offeringsFragment } from "../../fragments/operations/queries/fragments/offerings.js";
import { commercialCategoryFragment, frameFeaturesFragment, lensFeaturesFragment } from "../../fragments/operations/queries/fragments/small-fragments.js";
const GET_FRAMES_BY_SLUG = gql`
  query GetFramesBySlug($slug: String!) {
    getProductBySlug(slug: $slug) {
      product {
        __typename
        ... on FrameProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          productTypeDetails {
            isExclusiveBrand
            isOfferedWithPrescriptions
            offerings {
              ...offeringsFragment
            }
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              isReservable
              isInsuranceReimbursable
              brandModel
              brandModelCode
              brandModelColorCode
              channelAvailability
              trend
              segment
              targetGender
              targetGenderAllLocales {
                locale
                value
              }
              faceShape {
                shape
                displayNameAllLocales {
                  locale
                  value
                }
              }
              isVtoEnabled
              frameFeatures {
                ...frameFeaturesFragment
              }
              lensFeatures {
                ...lensFeaturesFragment
              }
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
  ${offeringsFragment}
  ${frameFeaturesFragment}
  ${lensFeaturesFragment}
`;
export {
  GET_FRAMES_BY_SLUG
};
//# sourceMappingURL=get-frames-by-slug.js.map
